export const CONFIG_ACCESS_ROLES = ['Admin'] as const;

type UserWithRoles = { roles?: Array<{ key: string }> } | null | undefined;

export function isConfigReadOnly(user: UserWithRoles): boolean {
  if (!user?.roles?.length) {
    return false;
  }

  const hasReadOnly = user.roles.some((r) => r.key === 'ReadOnly');
  const hasConfigAccess = user.roles.some((r) =>
    (CONFIG_ACCESS_ROLES as readonly string[]).includes(r.key)
  );

  return hasReadOnly && !hasConfigAccess;
}
